import { getIn, useFormikContext } from "formik";
import { ImCheckboxChecked, ImCheckboxUnchecked } from "react-icons/im";
import InputFormik from "../../../../../common/components/form/InputFormik";
import { maskCPF } from "../../../../../common/helpers/mask.helpers";

type CpfDoIndicadorCheckProps = {
  indicated: boolean;
  notIndicated: boolean;
};

function CpfDoIndicadorCheck({ invalidCpf }) {
  const { setFieldValue, values } = useFormikContext();

  const cpfDoIndicadorOptions: CpfDoIndicadorCheckProps = getIn(values, 'cpfDoIndicadorOptions')
  const cpfDoIndicador = getIn(values, 'cpfDoIndicador')

  return (
    <div className="grid grid-cols-2 gap-2 mb-2">
      <div className="relative h-20 w-full sm:w-full color flex flex-col space-y-4">
        <p className="text-md font-semibold text-gray-600">Foi indicado por alguém?</p>
        <div className="flex items-center space-x-4">
          <label htmlFor="cpfDoIndicadorOptions.indicated" className="flex items-center space-x-2 text-sm font-medium text-gray-600 cursor-pointer">
            <input
              id="cpfDoIndicadorOptions.indicated"
              name="cpfDoIndicadorOptions.indicated"
              type="checkbox"
              checked={cpfDoIndicadorOptions.indicated}
              onChange={() => {
                setFieldValue('cpfDoIndicadorOptions.indicated', true);
                setFieldValue('cpfDoIndicadorOptions.notIndicated', false);
              }}
              className="hidden"
            />
            {cpfDoIndicadorOptions.indicated ? (
              <ImCheckboxChecked className="text-greenPrimary" />
            ) : (
              <ImCheckboxUnchecked className="text-redPrimary" />
            )}
            <span>Sim</span>
          </label>
          <label
            htmlFor="cpfDoIndicadorOptions.notIndicated"
            className={`flex items-center space-x-2 text-sm font-medium text-gray-600 ${cpfDoIndicador && cpfDoIndicadorOptions.indicated ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
              }`}
          >
            <input
              id="cpfDoIndicadorOptions.notIndicated"
              name="cpfDoIndicadorOptions.notIndicated"
              type="checkbox"
              checked={cpfDoIndicadorOptions.notIndicated}
              onChange={() => {
                if (!cpfDoIndicador) {
                  setFieldValue('cpfDoIndicadorOptions.indicated', false);
                  setFieldValue('cpfDoIndicadorOptions.notIndicated', true);
                }
              }}
              className="hidden"
              disabled={!!cpfDoIndicador && cpfDoIndicadorOptions.indicated}
            />
            {cpfDoIndicadorOptions.notIndicated ? (
              <ImCheckboxChecked className="text-greenPrimary" />
            ) : (
              <ImCheckboxUnchecked className="text-redPrimary" />
            )}
            <span>Não</span>
          </label>
        </div>
      </div>
      <div></div>
      <div>
        {cpfDoIndicadorOptions.indicated ? (
          <InputFormik
            label="CPF da pessoa que indicou:"
            name="cpfDoIndicador"
            mask={maskCPF}
            required={cpfDoIndicadorOptions.indicated}
            readonly={!invalidCpf}
          />
        ) : null}
      </div>
    </div>
  );
}

export default CpfDoIndicadorCheck;

